export var NavbarComponents = {
    parts: ['button'],
    baseStyle: {
        button: {
            borderRadius: '3px',
        },
    },
};
